export function formatPersonalNumber(val: string): string {
    if (!val) return '';
    const digits = val.replace(/\D/g, '');
    if (digits.length <= 8) return digits;
    return digits.slice(0, -4) + '-' + digits.slice(-4);
  }

export function parsePersonalNumber(val: string): string {
    return (val || '').replace(/\D/g, '');
  }